import styled from 'foundations-theming-specialty/utils';
import { keyframes } from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const pulse = keyframes(["50%{opacity:0.5;}"]);
const SkeletonBar = styled.div.withConfig({
  displayName: "InboxNavTicketRowSkeleton__SkeletonBar"
})(["inline-size:", ";block-size:12px;border-radius:", ";background-color:", ";animation:", " 2s cubic-bezier(0.4,0,0.6,1) infinite;"], ({
  $inlineSize
}) => $inlineSize, ({
  theme
}) => theme.borderRadius[100], ({
  theme
}) => theme.color['fill-surface-recessed'], pulse);
const SkeletonRow = styled.div.withConfig({
  displayName: "InboxNavTicketRowSkeleton__SkeletonRow"
})(["border-block-end:", " solid ", ";"], ({
  theme
}) => theme.borderWidth[100], ({
  theme
}) => theme.color['border-core-subtle']);
export function InboxNavTicketRowSkeleton() {
  return /*#__PURE__*/_jsx(SkeletonRow, {
    role: "listitem",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "100",
      paddingBlock: "300",
      paddingInline: "600",
      justifyContent: "center",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        gap: "200",
        children: [/*#__PURE__*/_jsx(SkeletonBar, {
          $inlineSize: "50%"
        }), /*#__PURE__*/_jsx(SkeletonBar, {
          $inlineSize: "20%"
        })]
      }), /*#__PURE__*/_jsx(SkeletonBar, {
        $inlineSize: "80%"
      }), /*#__PURE__*/_jsx(SkeletonBar, {
        $inlineSize: "30%"
      })]
    })
  });
}